import { ChevronDown, MapPin } from 'lucide-react';
import { useContext, useEffect, useRef, useState } from 'react';
import { LocationContext } from '../../contextStore/LocationContext';
import { CITIES_BY_STATE, STATES } from '../../data/locations';
import './LocationDropdown.css';

function LocationDropdown() {
  const { browseLocation, setBrowseLocation } = useContext(LocationContext);
  const [open, setOpen] = useState(false);
  const [stateQuery, setStateQuery] = useState('');
  const [cityQuery, setCityQuery] = useState('');
  const [selectedState, setSelectedState] = useState(
    browseLocation?.state || ''
  );
  const [selectedCity, setSelectedCity] = useState(browseLocation?.city || '');
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    if (open) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const displayLabel = browseLocation?.city
    ? browseLocation.state
      ? `${browseLocation.city}, ${browseLocation.state}`
      : browseLocation.city
    : browseLocation?.state || 'Nigeria';

  const filteredStates = stateQuery
    ? STATES.filter((s) => s.toLowerCase().includes(stateQuery.toLowerCase()))
    : STATES;

  const citiesForState = selectedState
    ? CITIES_BY_STATE[selectedState] || []
    : [];
  const filteredCities = cityQuery
    ? citiesForState.filter((c) =>
        c.toLowerCase().includes(cityQuery.toLowerCase())
      )
    : citiesForState;

  const handleApply = () => {
    if (selectedState && selectedCity) {
      setBrowseLocation({ state: selectedState, city: selectedCity });
    } else if (selectedState) {
      setBrowseLocation({ state: selectedState, city: '' });
    }
    setOpen(false);
  };

  const handleClear = () => {
    setBrowseLocation({ state: '', city: '' });
    setSelectedState('');
    setSelectedCity('');
    setOpen(false);
  };

  return (
    <div className="locationDropdownWrap" ref={dropdownRef}>
      <button
        type="button"
        className="headerLocationBtn"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span className="headerLocationIcon">
          <MapPin />
        </span>
        <span className="headerLocationLabel">{displayLabel}</span>
        <ChevronDown size={20} className="headerLocationArrow" />
      </button>
      {open && (
        <div className="locationDropdownPanel">
          <div className="locationDropdownSection">
            <label htmlFor="location-state-input">State</label>
            <input
              id="location-state-input"
              type="text"
              placeholder="Search state..."
              value={selectedState ? stateQuery || selectedState : stateQuery}
              onChange={(e) => {
                setStateQuery(e.target.value);
                if (!e.target.value) setSelectedState('');
              }}
            />
            <ul className="locationDropdownList">
              <li>
                <button
                  type="button"
                  className={!selectedState ? 'selected' : ''}
                  onClick={() => {
                    setSelectedState('');
                    setSelectedCity('');
                    setBrowseLocation({ state: '', city: '' });
                    setOpen(false);
                    setStateQuery('');
                  }}
                >
                  All States (Nigeria)
                </button>
              </li>
              {filteredStates.map((s) => (
                <li key={s}>
                  <button
                    type="button"
                    className={selectedState === s ? 'selected' : ''}
                    onClick={() => {
                      setSelectedState(s);
                      setSelectedCity('');
                      setStateQuery('');
                    }}
                  >
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          {selectedState && (
            <div className="locationDropdownSection">
              <label htmlFor="location-city-input">City</label>
              <input
                id="location-city-input"
                type="text"
                placeholder="Search city..."
                value={selectedCity ? cityQuery || selectedCity : cityQuery}
                onChange={(e) => {
                  setCityQuery(e.target.value);
                  if (!e.target.value) setSelectedCity('');
                }}
              />
              <ul className="locationDropdownList">
                {filteredCities.map((c) => (
                  <li key={c}>
                    <button
                      type="button"
                      className={selectedCity === c ? 'selected' : ''}
                      onClick={() => {
                        setSelectedCity(c);
                        setCityQuery('');
                      }}
                    >
                      {c}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <div className="locationDropdownActions">
            <button
              type="button"
              className="locationDropdownClear"
              onClick={handleClear}
            >
              Clear
            </button>
            <button
              type="button"
              className="locationDropdownApply"
              onClick={handleApply}
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default LocationDropdown;
